'use client';
import { createContext, useContext } from "react";

const KitContext = createContext(null);

export function KitProvider({ value, children }) {
    return (
        <KitContext.Provider value={value}>
            {children}
        </KitContext.Provider>
    );
}

export function useKit() {
    const ctx = useContext(KitContext);
    if (!ctx) throw new Error('useKit must be used within a KitProvider');
    return ctx;
}
